import { render, staticRenderFns } from "./UserIndexView.vue?vue&type=template&id=0b480d84"
import script from "./UserIndexView.vue?vue&type=script&lang=js"
export * from "./UserIndexView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports